import { render } from "./MainTypeOfProducts.vue?vue&type=template&id=508077dc&scoped=true"
import script from "./MainTypeOfProducts.vue?vue&type=script&lang=js"
export * from "./MainTypeOfProducts.vue?vue&type=script&lang=js"

import "./MainTypeOfProducts.vue?vue&type=style&index=0&id=508077dc&scoped=true&lang=css"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508077dc"]])

export default __exports__